import {ValueObject} from '@s-ui/domain'

import {RatingFeatureValueObject} from './RatingFeatureValueObject.js'

export class RatingFeatureListValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static createFromPrimitives({value}) {
    return new RatingFeatureListValueObject({
      value: value.map(ratingFeature =>
        RatingFeatureValueObject.createFromPrimitives({
          type: ratingFeature.type,
          label: ratingFeature.label,
          score: ratingFeature.value
        })
      )
    })
  }

  get value() {
    return this.#value.map(ratingFeature => ratingFeature.value)
  }
}
